import { readonly, ref } from "vue";
// Shared channel: the active side panel publishes its inline footprint in px (inline-end viewport edge → its inline-start edge; 0 when none open) so a peer at the inline-end corner (e.g. the PiP media player) can sit clear of it.
// Single writer: assumes one open RecSidebar at a time.
const inlineExtent = ref(0);
// `open` flips true a tick or two before the panel element is laid out; while its
// measured width is 0 the rect reads all-zeros, so `viewportWidth - rootLeft`
// (rootLeft 0) would publish a phantom full-viewport extent and make a peer (PiP)
// lunge to clear nothing. Hold at 0 until the panel actually has a box.
export const computeSidebarInlineExtent = (params) => {
    if (!params.open || params.panelWidth <= 0)
        return 0;
    return Math.max(0, params.isRTL ? params.rootRight : params.viewportWidth - params.rootLeft);
};
export const useSidebarExtent = () => ({
    inlineExtent: readonly(inlineExtent),
    setInlineExtent: (value) => {
        inlineExtent.value = value;
    }
});
